// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Back and Continue buttons for a per-currency close review step. Continue stays disabled until
 * every entry is reviewed.
 */
import {
  ChevronLeftRounded,
  ChevronRightRounded,
} from '@/constants/hardfin-standard-icons';
import { Box, Button, Tooltip } from '@mui/material';

interface Props {
  onBack: () => void;
  onNext: () => void;
  continueLabel: string;
  allReviewed: boolean;
  onContinueBlocked: () => void;
}

export function ReviewStepNavigation(props: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 1,
        marginBottom: 3,
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<ChevronLeftRounded fontSize="small" />}
        onClick={props.onBack}
      >
        Back
      </Button>
      <Tooltip
        arrow
        title={
          !props.allReviewed &&
          'Please review journal entries above before proceeding'
        }
      >
        {/* A disabled button swallows pointer events, so the wrapper catches the click and
            points the user at the next unreviewed entry instead. */}
        <Box onClick={props.allReviewed ? undefined : props.onContinueBlocked}>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            endIcon={<ChevronRightRounded fontSize="small" />}
            onClick={props.onNext}
            disabled={!props.allReviewed}
          >
            {props.continueLabel}
          </Button>
        </Box>
      </Tooltip>
    </Box>
  );
}
